requestAnimationFrame(() => {
  themeBase.onDOMContentLoadedTrigger(() => {
    if (!customElements.get('localization-form')) {
      customElements.define(
        'localization-form',
        class LocalizationForm extends HTMLElement {
          constructor() {
            super();

            this.elements = {
              input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
              button: this.querySelector('button'),
              panel: this.querySelector('ul'),
            };
            this.elements.button.addEventListener('click', this.openSelector.bind(this));
            this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

            this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));

            this.closeSelectorHandler = this.closeSelector.bind(this);
          }

          hidePanel() {
            this.elements.button.setAttribute('aria-expanded', 'false');
            this.elements.panel.setAttribute('hidden', true);
          }

          onContainerKeyUp(event) {
            if (event.code.toUpperCase() !== 'ESCAPE') return;

            this.hidePanel();
            this.elements.button.focus();
          }

          onItemClick(event) {
            event.preventDefault();
            const form = this.querySelector('form');
            this.elements.input.value = event.currentTarget.dataset.value;
            if (form) form.submit();
          }

          addBodyHandler() {
            document.body.addEventListener('click', this.closeSelectorHandler);
          }

          removeBodyHandler() {
            document.body.removeEventListener('click', this.closeSelectorHandler);
          }

          openSelector() {
            this.elements.panel.toggleAttribute('hidden');
            this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
            !this.elements.panel.hasAttribute('hidden') ? this.addBodyHandler() : this.removeBodyHandler();
          }

          closeSelector(event) {
            if (!this.contains(event.target)) {
              this.hidePanel();
              this.removeBodyHandler();
            }
          }
        }
      );

      scriptController.scripts.push('localization-form.js');
    }
  });
});